
    function collapsibleTabs() {
          document.addEventListener('DOMContentLoaded', function() {

            const sourceContent = document.getElementById('collapsible-info');
            const targetContainer = document.getElementById('collapsible-tab-content'); 
            
            if (sourceContent && targetContainer) {
              // Clone the content to preserve event listeners if needed
              const clonedContent = sourceContent.cloneNode(true);
              clonedContent.style.display = 'block';
              clonedContent.id = 'moved-collapsible-tabs'; // Change ID to avoid duplicates
              
              // Move the content
              targetContainer.appendChild(clonedContent);
              sourceContent.style.display = 'none';
            }
          // FAQ Switch
            const sourceFAQContent = document.getElementById('collapsible-faq');
            const targetFAQContainer = document.getElementById('collapsible-faq-content'); 
            if (sourceFAQContent && targetFAQContainer) {
              // Clone the content to preserve event listeners if needed
              const clonedContentFAQ = sourceFAQContent.cloneNode(true);
              clonedContentFAQ.style.display = 'block';
              clonedContentFAQ.id = 'moved-collapsible-tabs'; // Change ID to avoid duplicates
              
              // Move the content
              targetFAQContainer.appendChild(clonedContentFAQ);
              sourceFAQContent.style.display = 'none';
            }  
          });
    }

    function trustIcons() {
          document.addEventListener('DOMContentLoaded', function() {
          // console.log('icons');
            const sourceContent = document.getElementById('product-trust-icons');
            const targetContainer = document.getElementById('trust-icons-tab-content'); 
            
            if (sourceContent && targetContainer) {
              // Clone the content to preserve event listeners if needed
              const clonedContent = sourceContent.cloneNode(true);
              clonedContent.style.display = 'block';
              clonedContent.id = 'moved-trust-icons'; // Change ID to avoid duplicates
              
              // Move the content
              targetContainer.appendChild(clonedContent);
              sourceContent.style.display = 'none';
            }
          });
    }    



    function tabsDropdown(){
                document.addEventListener('DOMContentLoaded', function() {
            const dropdown = document.getElementById('tabDropdown');
            
            if (dropdown) {
              dropdown.addEventListener('change', function() {
                const anchorValue = this.value;
                
                if (anchorValue) {
                  // Find the element with the ID
                  const targetElement = document.getElementById(anchorValue);
                  
                  if (targetElement) {
                    // Smooth scroll to the element
                    targetElement.scrollIntoView({ 
                      behavior: 'smooth',
                      block: 'start'
                    });
                    
                    // Optional: Update URL hash without jumping
                    history.pushState(null, null, '#' + anchorValue);
                  }
                }
              });
            }
          });
    }



    function dropdownToggle() {
          document.addEventListener('DOMContentLoaded', function() {
            const toggle = document.getElementById('dropdownToggle');
            const menu = document.getElementById('dropdownMenu');
            const overlay = document.getElementById('dropdownOverlay');
            const items = menu.querySelectorAll('.dropdown-item');
            
            // Toggle dropdown
            toggle.addEventListener('click', function(e) {
              e.stopPropagation();
              const isOpen = menu.classList.contains('show');
              
              if (isOpen) {
                closeDropdown();
              } else {
                openDropdown();
              }
            });
            
            // Open dropdown
            function openDropdown() {
              menu.classList.add('show');
              overlay.classList.add('show');
              toggle.classList.add('active');
              document.body.style.overflow = 'hidden'; // Prevent scrolling on mobile
            }
            
            // Close dropdown
            function closeDropdown() {
              menu.classList.remove('show');
              overlay.classList.remove('show');
              toggle.classList.remove('active');
              document.body.style.overflow = '';
            }
            
            // Close on overlay click
            overlay.addEventListener('click', closeDropdown);
            
            // Handle item clicks
            items.forEach(item => {
              item.addEventListener('click', function() {
                const target = this.getAttribute('data-target');
                const targetElement = document.getElementById(target);
                
                if (targetElement) {
                  // Close dropdown first
                  closeDropdown();
                  
                  // Small delay for smooth transition
                  setTimeout(() => {
                    const headerOffset = 80; // Adjust for sticky header
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                    
                    // Update URL
                    history.pushState(null, null, '#' + target);
                    
                    // Update dropdown label
                    toggle.querySelector('.dropdown-label').textContent = this.textContent;
                  }, 100);
                }
              });
            });
            
            // Close on escape key
            document.addEventListener('keydown', function(e) {
              if (e.key === 'Escape' && menu.classList.contains('show')) {
                closeDropdown();
              }
            });
          });
    }



    function tabsNav() {
          document.addEventListener('DOMContentLoaded', function() {
            const tabsNav = document.querySelector('#tabs-nav');
            
            if (!tabsNav) return;
            
            const tabItems = tabsNav.querySelectorAll('li[data-tab]');
            const tabContents = document.querySelectorAll('[data-tab-content]');
            
            // Debug: Log what we found
            
            
            
            function switchTab(targetTab) {
              // Remove active class from all tab list items
              tabItems.forEach(item => {
                item.classList.remove('active');
              });
              
              // Hide all tab contents
              tabContents.forEach(content => {
                content.classList.add('tab-hidden');
                content.classList.remove('active', 'tab-visible');
              });
              
              // Add active class to clicked tab list item
              const activeItem = tabsNav.querySelector(`li[data-tab="${targetTab}"]`);
              if (activeItem) {
                activeItem.classList.add('active');
              }
              
              // Show corresponding tab content
              const activeContent = document.querySelector(`[data-tab-content="${targetTab}"]`);
              
              
              
              if (activeContent) {
                activeContent.classList.remove('tab-hidden');
                activeContent.classList.add('active', 'tab-visible');
                
              } else {
                
              }
            }
            
            // Add click event listeners to all tab list items
            tabItems.forEach(item => {
              item.addEventListener('click', function(e) {
                e.preventDefault();
                const targetTab = this.getAttribute('data-tab');
                
                switchTab(targetTab);
              });
            });
            
            // Initialize first tab as active on page load
            if (tabItems.length > 0) {
              const firstTab = tabItems[0].getAttribute('data-tab');
              switchTab(firstTab);
            }
          });
    }

    function clickStars() {
      document.querySelectorAll('.klaviyo-star-rating-widget').forEach(label => {
        
        label.addEventListener('click', () => {
          // Find all elements with tab-visible and replace with tab-hidden
          //  console.log('click stars');
          document.querySelectorAll('.tab-visible').forEach(el => {
            el.classList.remove('tab-visible');
            el.classList.add('tab-hidden');
          });
          
          // Add tab-visible to .tab-content.reviews
          const reviewsTab = document.querySelector('.tab-content.reviews');
          if (reviewsTab) {
            reviewsTab.classList.remove('tab-hidden');
            reviewsTab.classList.add('tab-visible');
          }
        });
      });
    }
document.addEventListener('click', function(e) {
  var starWidget = e.target.closest('.klaviyo-star-rating-widget, .kl_reviews__star_rating_widget');
  if (!starWidget) return;

  var tab6 = document.getElementById('tab6');
  if (tab6) {
    var siblings = tab6.parentElement.children;
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('active', 'tab-visible');
      siblings[i].classList.add('tab-hidden');
    }
    tab6.classList.remove('tab-hidden');
    tab6.classList.add('active', 'tab-visible');
  }

  var tabsNav = document.getElementById('tabs-nav');
  if (tabsNav) {
    var navItems = tabsNav.children;
    for (var i = 0; i < navItems.length; i++) {
      navItems[i].classList.remove('active');
    }
    if (navItems[5]) {
      navItems[5].classList.add('active');
    }
  }

  // Scroll with offset for sticky nav
  // Scroll to tabs
  var tabsContainer = document.getElementById('product-tab-container');
  if (tabsContainer) {
    tabsContainer.scrollIntoView({ behavior: 'smooth' });
  }
}, true);